import React from "react";
import { FaBox, FaBalanceScale, FaCog, FaChartLine, FaPlusCircle, FaMoneyBill } from "react-icons/fa";
import "./TallyFieldPage.css";

const InventoryManagement = () => {
  const sections = [
    {
      title: "Define Groups & Locations",
      content: "Define unlimited groups, categories, batches, and locations/godowns with ease, adapting to your business lines seamlessly.",
      icon: <FaBox />,
    },
    {
      title: "Flexible Units of Measure",
      content: "Handle complexities like dual requirements for bag and box sizes with support for multiple units of measure.",
      icon: <FaBalanceScale />,
    },
    {
      title: "Manufacturing Journal",
      content: "Record the entire manufacturing cycle, tracking raw materials consumption, production, and by-product records.",
      icon: <FaCog />,
    },
    {
      title: "Bill of Material",
      content: "Define raw materials, components, and assemblies required for manufacturing with the comprehensive BoM feature.",
      icon: <FaChartLine />,
    },
    {
      title: "Re-order Level Tracking",
      content: "Track stock levels and set minimum thresholds to ensure optimal replenishment and never miss an order.",
      icon: <FaPlusCircle />,
    },
    {
      title: "Stock Valuation Methods",
      content: "Value stock using various methods like Average Cost, FIFO, and more for accurate financial reporting.",
      icon: <FaMoneyBill />,
    },
  ];

  return (
    <div className="tally-field-page">
      <div className="tally-field-container">
        <header className="tally-field-header">
          <span className="subtitle">Core Feature</span>
          <h1>Inventory Management</h1>
          <p>Complete control over your stock, from manufacturing to multi-location storage.</p>
        </header>

        <div className="tally-field-grid">
          {sections.map((section, index) => (
            <div className="tally-field-card" key={index}>
              <div className="icon-wrapper">
                {section.icon}
              </div>
              <div className="card-content">
                <h3>{section.title}</h3>
                <p>{section.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InventoryManagement;
